<h5 id="title" class="title">Change password</h5>
<ngx-change-password-form></ngx-change-password-form>
<!-- <ngx-change-password ></ngx-change-password> -->
